<template>

    <div>

        <!-- show loading indicator -->
    	<loading-indicator :loading="isLoading"></loading-indicator>

    	<template v-if="!isLoading">

            <template v-if="logs.length > 0">

                <log-changes :history="logs"></log-changes>

            </template>

            <template v-else>

                <lang labelKey="PIM-PRODUCT-NO_LOGS_AVAILABLE"></lang>

            </template>

        </template>

    </div>

</template>



<script>
import LogChanges from '../utils/incl-logChanges';

export default {

  name: 'pimProductLogs',

	components: {
		LogChanges
	},

	data() {

		return {
      productId: null,
      isLoading: false,
      logs: [],
    }

  },

  created() {

      this.productId = this.$route.params.id;
      this.init();

  },

  methods: {

    init() {

      this.isLoading = true;

      this.axios.get(this.$config.api + 'pimProduct/'+this.productId+'?loadChangesLog=1')
          .then(res => {
              this.logs = res.data.changesLog;
              this.isLoading = false;
          })

    }

  }

}

</script>


<style>


</style>
